module.exports = __webpack_public_path__ + "img/logo.bf0259bc.svg";